export const errorMessages: Record<string, string | undefined> = {
  AlreadyMinted: "This HyperCert has already been claimed",
  ConflictingClaim: "This claim conflicts with an existing claim",
  DuplicateEntry: "This fraction has already been minted",
};
